'use strict';

wbApp.controller('SurveyAnswersCtrl', ['$scope', '$modal', 'surveyResponseSvc',
function ($scope, $modal, surveyResponseSvc) {

    $scope.$on('surveySelectionChanged', function (e, newlySelectedSurvey) {
        if ($scope.survey.surveyID !== newlySelectedSurvey.surveyID) {
            $scope.surveyAnswers = surveyResponseSvc.getAllBySurveyIDAsync(newlySelectedSurvey.surveyID);
            $scope.survey = newlySelectedSurvey;
        }
    });

    $scope.surveyAnswersFilterOptions = {
        filterText: ""
    };

    $scope.onShowAnswers = function (data) {
        detailDialogPromise.$promise.then(function () {
            detailDialogPromise.$scope.survey = angular.copy($scope.survey);
            detailDialogPromise.$scope.surveyResponseID = data.surveyResponseID;
            detailDialogPromise.show();
        });
    }

    $scope.onGetExcelExport = function () {

        function success(data)
        {
            $("#dataDownloadIFrame").remove();
            $("body").append("<iframe id='dataDownloadIFrame' src='/Api/SurveyResponses/Download?fileName=" + data.fileName + "' style='height: 0px;' ></iframe>");
        }

        function error(data)
        {

        }

        var res = surveyResponseSvc.getExcelExportBySurveyID($scope.survey.surveyID);
        res.$promise.then(success, error);
    }

    $scope.surveyAnswers = [];
    $scope.survey = {};

    $scope.answersGridOptions = {
        sortInfo: { fields: ['filledAt'], directions: ['dsc'] },
        columnDefs: [
            { field: 'studentFullName', displayName: "TXT_LBL_STUDENT", sort: 'humanName', width: '180px' },
            { field: 'semesterName', displayName: "TXT_LBL_SEMESTER", width: '120px' },
            { field: 'firstDate', displayName: "TXT_SEC_COURSE_SCHEDULE", cellFilter: 'date:EEE HH:mm', width: '80px' },
            { field: 'subjectName', displayName: "TXT_LBL_SUBJECT", width: '190px' },
            { field: 'courseFullName', displayName: "TXT_VAL_RCPG_COURSE", },
            { field: 'teacherFullName', displayName: "TXT_LBL_EMPLOYEE", width: '180px' },
            { field: 'filledAt', displayName: "TXT_LBL_CREATED_AT", cellFilter: "date:'short'", width: '110px' },
            { field: 'pctRating', displayName: "TXT_LBL_RATING", cellFilter: "number:2", width: '80px' },
        ],
        customCmds: [
            {
                text: 'TXT_MENU_VIEW_ANSWER',
                command: function (row) { $scope.onShowAnswers(row); }
            }, {
                text: 'TXT_EXPORT_SURVEY_ANSWERS_TO_EXCEL',
                command: function () { $scope.onGetExcelExport(); }
            }]
    };

    var detailDialogPromise = $modal({
        templateUrl: 'survey/survey-detail-tabs/answer-detail.html',
        show: false,
        scope: $scope.$new()
    });


}]);
